interface IconProps { name: IconName; size?: number; className?: string; strokeWidth?: number }

export type IconName =
  | 'menu' | 'bell' | 'eye' | 'eye-off' | 'chevron-down' | 'chevron' | 'plus' | 'close'
  | 'search' | 'camera' | 'check' | 'warning' | 'sparkle' | 'trash' | 'settings'
  | 'dashboard' | 'transactions' | 'budget' | 'goals' | 'profile'
  | 'wallet' | 'arrow-down' | 'arrow-up' | 'pie' | 'transfer' | 'shield'
  | 'home' | 'car' | 'fork' | 'bag' | 'cup' | 'heart' | 'dots' | 'plane' | 'book'
  | 'gift' | 'phone' | 'repeat' | 'piggy' | 'chart' | 'briefcase' | 'basket'
  | 'bolt' | 'umbrella' | 'credit-card' | 'scissors' | 'ticket' | 'moped' | 'percent' | 'question';

const PATHS: Record<IconName, string> = {
  menu: 'M4 7h16M4 12h16M4 17h16',
  bell: 'M6 9a6 6 0 1 1 12 0c0 4 1.5 5.5 1.5 5.5h-15S6 13 6 9ZM10 18.5a2 2 0 0 0 4 0',
  eye: 'M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Zm9.5 2.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z',
  'eye-off': 'M4 4l16 16M9.9 5.9A9.6 9.6 0 0 1 12 5.5c6 0 9.5 6.5 9.5 6.5a17 17 0 0 1-3.2 3.9M6.4 7.7A16.8 16.8 0 0 0 2.5 12S6 18.5 12 18.5c1 0 1.9-.2 2.8-.5',
  'chevron-down': 'm6 9 6 6 6-6',
  chevron: 'm14 6-6 6 6 6',
  plus: 'M12 5v14M5 12h14',
  close: 'M6 6l12 12M18 6 6 18',
  search: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14ZM20 20l-4-4',
  camera: 'M4 8h3l1.5-2h7L17 8h3v11H4zM12 16.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z',
  check: 'm5 13 4.5 4.5L19 7',
  warning: 'M12 4 2.5 20h19zM12 10v4M12 17.2v.1',
  sparkle: 'M12 4l1.8 4.7L18.5 10l-4.7 1.8L12 16.5l-1.8-4.7L5.5 10l4.7-1.3z',
  trash: 'M5 7h14M10 7V5h4v2M6.5 7l.8 12h9.4l.8-12M10 11v5M14 11v5',
  settings: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm8-3a8 8 0 0 0-.2-1.7l2-1.5-2-3.4-2.3 1a8 8 0 0 0-2.9-1.7L14.2 2H9.8l-.4 2.7a8 8 0 0 0-2.9 1.7l-2.3-1-2 3.4 2 1.5A8 8 0 0 0 4 12c0 .6.1 1.2.2 1.7l-2 1.5 2 3.4 2.3-1a8 8 0 0 0 2.9 1.7l.4 2.7h4.4l.4-2.7a8 8 0 0 0 2.9-1.7l2.3 1 2-3.4-2-1.5c.1-.5.2-1.1.2-1.7Z',

  dashboard: 'M3 10.5 12 3l9 7.5M5.5 9.5V20a1 1 0 0 0 1 1H10v-5.5h4V21h3.5a1 1 0 0 0 1-1V9.5',
  transactions: 'M6 3h9l4 4v14H6zM9 8h5M9 12h7M9 16h7',
  budget: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12 12V3M12 12l6.4 6.4',
  goals: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-5a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-3.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z',
  profile: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM4.5 20a7.5 7.5 0 0 1 15 0',

  wallet: 'M3 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM16 12h4M16.5 12v.01',
  'arrow-down': 'M12 5v14M6 13l6 6 6-6',
  'arrow-up': 'M12 19V5M6 11l6-6 6 6',
  pie: 'M12 3v9h9a9 9 0 1 1-9-9Z',
  transfer: 'M4 8h13l-3-3M20 16H7l3 3',
  shield: 'M12 3 20 6v6c0 5-3.5 7.5-8 9-4.5-1.5-8-4-8-9V6z',

  home: 'M3 10.5 12 3l9 7.5M5.5 9.5V20a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V9.5',
  car: 'M5 16.5h14M6.5 16.5V19H4.5v-2.5M19.5 16.5V19h-2v-2.5M4 16.5v-4l2-5h12l2 5v4zM7.5 13h2M14.5 13h2',
  fork: 'M7 3v7a2 2 0 0 0 4 0V3M9 12v9M16 3c-1.5 1-2 3-2 5s.5 3 2 3v10',
  bag: 'M5.5 8h13l1 12h-15zM9 8V6a3 3 0 0 1 6 0v2',
  cup: 'M5 8h11v6a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4zM16 10h1.5a2.5 2.5 0 0 1 0 5H16M4 21h13',
  heart: 'M12 20s-7-4.4-7-9a4 4 0 0 1 7-2.6A4 4 0 0 1 19 11c0 4.6-7 9-7 9Z',
  dots: 'M6 12h.01M12 12h.01M18 12h.01',
  plane: 'M10.5 20.5 12 15l7.5-2.5 1-3-8.5 2L8 6.5 6 7l2.5 5-4 1.2-1.5-2-1.5.5 2 4.3z',
  book: 'M5 4h9a3 3 0 0 1 3 3v13H8a3 3 0 0 1-3-3zM17 7h2v13H8',
  gift: 'M4 11h16v9H4zM4 8h16v3H4zM12 8v12M12 8S9.5 4 7.5 5.5 9 8 12 8Zm0 0s2.5-4 4.5-2.5S15 8 12 8Z',
  phone: 'M7 3h10v18H7zM10.5 18.5h3',
  repeat: 'M4 9a5 5 0 0 1 5-5h11l-3-3M20 15a5 5 0 0 1-5 5H4l3 3',
  piggy: 'M4 12a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v3h-2l-1 3h-3l-.5-2h-3l-.5 2H7l-1-3H4zM15 10.5v.01',
  chart: 'M4 19V5M4 19h16M8 15l3.5-4.5L15 14l4-6',
  briefcase: 'M4 8h16v12H4zM9 8V6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2',
  basket: 'M4 9h16l-1.5 11h-13zM8 9l2-5M16 9l-2-5',
  bolt: 'M13 3 5 14h6l-1 7 8-11h-6z',
  umbrella: 'M12 4a8 8 0 0 1 8 8H4a8 8 0 0 1 8-8Zm0 8v6.5a2.5 2.5 0 0 0 5 0',
  'credit-card': 'M3 7h18v10H3zM3 11h18',
  scissors: 'M7 6.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm0 7a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM8.6 9.8 19 18M8.6 14.2 19 6',
  ticket: 'M4 8h16v3a2 2 0 0 0 0 4v3H4v-3a2 2 0 0 0 0-4zM12 8v8',
  moped: 'M6 18a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm12 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM9 15h6M6 12V8h4l3 5M14 6h3v6',
  percent: 'M6.5 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm11 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM6 19 19 5',
  question: 'M9.5 9a2.5 2.5 0 1 1 3.4 2.3c-.8.3-1.4 1-1.4 1.9v.3M12 17v.01M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z',
};

export function Icon({ name, size = 22, className, strokeWidth = 1.8 }: IconProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d={PATHS[name] ?? PATHS.dots} />
    </svg>
  );
}

/** Category slug -> icon + colour pair, so a row always looks the same everywhere. */
export const CATEGORY_STYLE: Record<string, { icon: IconName; color: string; soft: string }> = {
  housing:           { icon: 'home',        color: 'var(--c-blue)',   soft: 'var(--c-blue-soft)' },
  utilities:         { icon: 'bolt',        color: 'var(--c-blue)',   soft: 'var(--c-blue-soft)' },
  insurance:         { icon: 'umbrella',    color: 'var(--c-blue)',   soft: 'var(--c-blue-soft)' },
  transportation:    { icon: 'car',         color: 'var(--c-green)',  soft: 'var(--c-green-soft)' },
  health:            { icon: 'heart',       color: 'var(--c-red)',    soft: 'var(--c-red-soft)' },
  debt:              { icon: 'credit-card', color: 'var(--c-grey)',   soft: 'var(--c-grey-soft)' },
  groceries:         { icon: 'basket',      color: 'var(--c-red)',    soft: 'var(--c-red-soft)' },
  restaurants:       { icon: 'fork',        color: 'var(--c-red)',    soft: 'var(--c-red-soft)' },
  delivery:          { icon: 'moped',       color: 'var(--c-red)',    soft: 'var(--c-red-soft)' },
  shopping:          { icon: 'bag',         color: 'var(--c-pink)',   soft: 'var(--c-pink-soft)' },
  entertainment:     { icon: 'cup',         color: 'var(--c-purple)', soft: 'var(--c-purple-soft)' },
  travel:            { icon: 'plane',       color: 'var(--c-violet)', soft: 'var(--c-violet-soft)' },
  personal_care:     { icon: 'scissors',    color: 'var(--c-purple)', soft: 'var(--c-purple-soft)' },
  subscriptions:     { icon: 'repeat',      color: 'var(--c-purple)', soft: 'var(--c-purple-soft)' },
  savings:           { icon: 'piggy',       color: 'var(--c-green)',  soft: 'var(--c-green-soft)' },
  investments:       { icon: 'chart',       color: 'var(--c-green)',  soft: 'var(--c-green-soft)' },
  salary:            { icon: 'wallet',      color: 'var(--c-green)',  soft: 'var(--c-green-soft)' },
  freelance:         { icon: 'briefcase',   color: 'var(--c-green)',  soft: 'var(--c-green-soft)' },
  investment_income: { icon: 'chart',       color: 'var(--c-green)',  soft: 'var(--c-green-soft)' },
  other_income:      { icon: 'plus',        color: 'var(--c-green)',  soft: 'var(--c-green-soft)' },
  education:         { icon: 'book',        color: 'var(--c-blue)',   soft: 'var(--c-blue-soft)' },
  gifts:             { icon: 'gift',        color: 'var(--c-pink)',   soft: 'var(--c-pink-soft)' },
  fees:              { icon: 'percent',     color: 'var(--c-grey)',   soft: 'var(--c-grey-soft)' },
  miscellaneous:     { icon: 'dots',        color: 'var(--c-grey)',   soft: 'var(--c-grey-soft)' },
  transfer:          { icon: 'transfer',    color: 'var(--c-grey)',   soft: 'var(--c-grey-soft)' },
  uncategorized:     { icon: 'question',    color: 'var(--c-grey)',   soft: 'var(--c-grey-soft)' },
};

export const DEFAULT_CATEGORY_STYLE = { icon: 'dots' as IconName, color: 'var(--c-grey)', soft: 'var(--c-grey-soft)' };
